import { BaseAxios } from './AxiosInstances';

const GetPosts = (page, items = 10) => {
    return BaseAxios.get('posts?featuredFirst=true&page='+page+ "&items="+items)
}

const GetPost = (id) => {
    return BaseAxios.get('posts/' + id);
}

export default {
    GetPost,
    GetPosts
}